'use client';
import { BannerCard } from '../ui/cards';
import Container from '@/components/ui/container';
import useInViewPort from '@/hooks/useInViewPort';
import { event_view_promotion } from '@/utils/gtm';

const Banners = ({ data, isMobile, locale }) => {
  const fireViewPromotion = () => {
    if (data?.value?.length > 0) {
      const updatedData = data?.value?.map((item) => ({
        promotionImage: item?.[`img-${locale}`],
        key: data?.key,
        position: data?.position,
        id: item?.id,
        name: data?.[`title-${locale}`] || item?.[`alt-${locale}`],
      }));
      event_view_promotion(updatedData);
    }
  };
  const [ref] = useInViewPort(fireViewPromotion);
  const length =
    data?.value?.length === 1
      ? 'grid-cols-1'
      : data?.value?.length === 2
        ? 'grid-cols-1 md:grid-cols-2'
        : data?.value?.length === 3
          ? 'grid-cols-1 md:grid-cols-3'
          : 'grid-cols-1 md:grid-cols-4';

  return (
    <Container
      className={`my-8 grid py-0 max-lg:my-5 max-md:my-0 ${length} gap-6 max-lg:gap-4 max-md:gap-2 max-sm:gap-4`}
    >
      {data?.value?.map((info, index) => (
        <BannerCard
          key={index}
          info={info}
          locale={locale}
          isMobile={isMobile}
          ref={ref}
          sliderKey={data?.key}
          position={data?.position}
        />
      ))}
    </Container>
  );
};

export default Banners;
